import { Application } from '@prisma/client';
import { Injectable } from '@angular/core';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { of, Subject } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  createItemEffect,
  deleteItemEffect,
  loadListEffect,
  updateItemEffect,
} from '../../shared/crud/effects';
import {
  createItem,
  deleteItem,
  loadList,
  updateItem,
} from './application.actions';
import { ApplicationRepository } from './application.repository';
import { ApplicationService } from './application.service';

@Injectable({ providedIn: 'root' })
export class ApplicationEffects {
  public notify$ = new Subject<{
    action: { type: string };
    payload?: unknown;
  }>();

  constructor(
    private repository: ApplicationRepository,
    private service: ApplicationService,
    private toast: HotToastService
  ) { }

  loadEntities$ = loadListEffect<Application>({
    action: loadList,
    repository: this.repository,
    serviceAction: () => this.service.findAll(),
    toast: this.toast,
  });

  createEntity$ = createItemEffect<Application>({
    action: createItem,
    repository: this.repository,
    serviceAction: (entity) => this.service.create(entity),
    toast: this.toast,
  });

  updateEntity$ = updateItemEffect<Application>({
    action: updateItem,
    repository: this.repository,
    serviceAction: (id, changes) => this.service.update(id, changes),
    toast: this.toast,
  });

  deleteEntity$ = deleteItemEffect<Application>({
    action: deleteItem,
    repository: this.repository,
    serviceAction: (id) => this.service.delete(id),
    toast: this.toast,
  });

  loadEntityById$ = (id: Application['id']) => {
    let toaster: CreateHotToastRef<unknown>;
    return of(id).pipe(
      switchMap((id) => {
        this.repository.updateStatus('item', 'pending');
        environment?.production ||
          (toaster = this.toast.loading(`Загрузка заявки`));
        return this.service.findOne(id).pipe(
          tap((entity) => {
            if (!environment?.production) {
              this.toast.success(`Заявка загружена`);
            }
            if (entity) {
              this.repository.updateEntity(entity.id, entity);
            }
          }),
          finalize(() => {
            toaster?.close();
          })
        );
      })
    );
  };
}
